// components/layouts/AuthenticatedLayout.tsx
import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { DashboardLayout } from "@/components/DashboardLayout";
import { Skeleton } from "@/components/ui/skeleton";
import { TooltipProvider } from "@/components/ui/tooltip";
import { SocketProvider } from "@/provider/SocketProvider";
import { SubscriptionProvider } from "@/provider/SubscriptionProvider";
import { useAuth } from "@/contexts/AuthContext";
import { AdminViewBanner } from "@/components/AdminViewBanner";

const AuthenticatedRouteFallback = () => (
  <div className="space-y-6">
    <Skeleton className="h-9 w-56" />
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
      {[...Array(4)].map((_, index) => (
        <Skeleton key={index} className="h-32 rounded-lg" />
      ))}
    </div>
    <Skeleton className="h-72 rounded-lg" />
  </div>
);

export const AuthenticatedLayout = () => {
  const { isAuthReady, isAuthenticated, isAdminView } = useAuth();

  return (
    <TooltipProvider>
      <SubscriptionProvider>
        <SocketProvider enabled={isAuthReady && isAuthenticated && !isAdminView}>
          {isAdminView && <AdminViewBanner />}
          <DashboardLayout>
            <Suspense fallback={<AuthenticatedRouteFallback />}>
              <Outlet />
            </Suspense>
          </DashboardLayout>
        </SocketProvider>
      </SubscriptionProvider>
    </TooltipProvider>
  );
};
